module.exports = __webpack_public_path__ + "static/trash-zoom-b05f17cb54b5e07da1990a32dbc19a1a.jpg";